// src/hooks/useBlockedNavigation.js
import { useContext, useEffect } from "react";
import { UNSAFE_NavigationContext } from "react-router-dom";

/**
 * Calls onTrigger() when navigation is attempted while shouldBlock = true.
 * No window.confirm — you show your own UI.
 */
export function useBlockedNavigation(shouldBlock, onTrigger) {
  const { navigator } = useContext(UNSAFE_NavigationContext);

  useEffect(() => {
    if (!shouldBlock) return;

    const originalPush = navigator.push;
    const originalReplace = navigator.replace;

    const blockNav = (originalFn) => (...args) => {
      onTrigger(() => originalFn.apply(navigator, args)); // pass a resume fn
    };

    navigator.push = blockNav(originalPush);
    navigator.replace = blockNav(originalReplace);

    return () => {
      navigator.push = originalPush;
      navigator.replace = originalReplace;
    };
  }, [shouldBlock, onTrigger, navigator]);
}
